import { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import { Form } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Select from 'react-select';
import { DeleteButton } from '../../../components/DeleteButton';

import { ButtonWithDisabledTooltip } from '../../../components/ButtonWithDisabledTooltip';

const maximumNumberOfContacts = 10;

class ModalContactGroupAddOrUpdateInternal extends Component {

    state = {
        contactGroupId: "",
        name: "",
        description: "",
        updatedContacts: [],
        contactOptions: [],
        selectedContactOption: null,
    }

    constructor(props) {
        super(props);

        // Build the description validation Regex.
        let nonPrintableCharStart = String.fromCharCode(0x00); // NULL char
        let nonPrintableCharEnd = String.fromCharCode(0x1F); // S7 char
        let delRegex = String.fromCharCode(0xF); // DEL char
        let backslashRegex = "\\\\"; // The parsing of the literal string will reduce this to 2 backslashes, the parsing of this string by the RegExp class will reduce it to a single literal backslash to be matched.
        let forwardslashRegex = "\\/"; 
        let bracketOpeningRegex = "\\["; 
        let bracketClosingRegex = "\\]"; 
        let quotationRegex = "\\\"";
        let additionalCharsRegex = "!@#$%^&*()={};:";

        this.nameValidationRegex = new RegExp(`^[^${nonPrintableCharStart}-${nonPrintableCharEnd}${delRegex}${backslashRegex}${forwardslashRegex}${bracketOpeningRegex}${bracketClosingRegex}${quotationRegex}]*$`);
        this.descriptionValidationRegex = new RegExp(`^[^${nonPrintableCharStart}-${nonPrintableCharEnd}${delRegex}${backslashRegex}${forwardslashRegex}${bracketOpeningRegex}${bracketClosingRegex}${quotationRegex}${additionalCharsRegex}]*$`);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.setInitialValues();
        }
    }

    setInitialValues = () => {
        const isUpdate = this.props.isUpdate;

        let updatedContacts = [];
        if (isUpdate) {
            this.props.contactGroupToUpdate.contacts.forEach(contact => {
                updatedContacts.push(contact);
            });
        }

        this.setState(
            {
                contactGroupId: isUpdate ? this.props.contactGroupToUpdate.contactGroupId : "",
                name: isUpdate ? this.props.contactGroupToUpdate.name : "",
                description: isUpdate ? this.props.contactGroupToUpdate.description : "",
                updatedContacts: updatedContacts,
            }
        );

        this.SetContactSelectState(updatedContacts);
    }

    SetContactSelectState = (currentContacts) =>{
        const availableContacts = this.getAvailableContactsExcept(currentContacts);

        var contactOptions = [];
        var selectedContactOption = null;

        availableContacts.forEach(availableContact => {
            var contactOption = {value:availableContact, label:availableContact.name};
            contactOptions.push(contactOption);

            if (!selectedContactOption)
            {
                selectedContactOption = contactOption;
            }
        });

        this.setState(
            {
                contactOptions: contactOptions,
                selectedContactOption: selectedContactOption,
            }
        );
    }

    handleDoneButtonClicked = () => {
        const trimmedName = this.state.name.trim();
        const trimmedDescription = this.state.description.trim();

        const contactsAdded = this.props.isUpdate ? 
            this.state.updatedContacts.filter(updatedContact => !this.props.contactGroupToUpdate.contacts.some(contact => contact.contactId === updatedContact.contactId)) :
            this.state.updatedContacts;
        const contactsRemoved = this.props.isUpdate ? this.props.contactGroupToUpdate.contacts.filter(contact => !this.state.updatedContacts.some(updatedContact => updatedContact.contactId === contact.contactId)) : [];

        const doneInfo = {
            contactGroupId: this.state.contactGroupId,
            name: trimmedName,
            description: trimmedDescription,
            contactsAdded: contactsAdded,
            contactsRemoved: contactsRemoved,
            isUpdate: this.props.isUpdate
        }

        this.props.onAddOrUpdate(doneInfo);
    }

    handleCancelButtonClicked = () => {
        this.props.onHide();
    }

    handleNameChanged = (e) => {
        const updatedName = e.target.value;

        if (updatedName.length > 0 && !this.nameValidationRegex.test(updatedName)) {
            return;
        }
                
        this.setState({
            name: updatedName
        });
    }

    handleDescriptionChanged = (e) => {
        const updatedDescription = e.target.value;

        if (updatedDescription.length > 0 && !this.descriptionValidationRegex.test(updatedDescription)) {
            return;
        }
                
        this.setState({
            description: updatedDescription
        });
    }

    handleContactAdd = () => {
        if (!this.state.selectedContactOption) {
            return;
        }

        let updatedContacts = this.state.updatedContacts;
        if (updatedContacts.some(updatedContact => updatedContact.contactId === this.state.selectedContactOption.value.contactId)) {
            return;
        }

        updatedContacts.push(this.state.selectedContactOption.value);
        this.SetContactSelectState(updatedContacts);

        this.setState({
            updatedContacts: updatedContacts,
        });
    }

    handleContactDelete = (contact) => {
        const updatedContacts = this.state.updatedContacts.filter(updatedContact => updatedContact.contactId !== contact.contactId);
        this.SetContactSelectState(updatedContacts);

        this.setState({
            updatedContacts: updatedContacts,            
        });
    }

    handleSelectedContactChange = (selectedContactOption) => {
        if (!this.state.selectedContactOption || !selectedContactOption || this.state.selectedContactOption.value !== selectedContactOption.value) {
            this.setState(
                {
                    selectedContactOption: selectedContactOption
                }
            );
        }
    }

    shouldAddOrUpdateButtonBeEnabled = () => {
        return this.getAddOrUpdateButtonTooltip() === null;
    }

    getAddOrUpdateButtonTooltip = () => {
        if (!this.props.isOpen) {
            return null;
        }

        if (this.state.name === '') {
            return "Name may not be empty";
        }

        if (this.state.name.length > 50) {
            return "Name must be less than 50 characters";
        }

        if (this.state.description.length > 256) {
            return "Description must be less than 256 characters";
        }

        if (this.state.name !== this.props.contactGroupToUpdate.name ||
            this.state.description !== this.props.contactGroupToUpdate.description ||
            this.IsContactsDifferent()) {
                return null;
        }

        return "No changes detected";
    }

    IsContactsDifferent = () => {
        if (this.state.updatedContacts.length !== this.props.contactGroupToUpdate.contacts.length) {
            return true;
        }

        this.state.updatedContacts.forEach(updatedContact => {
            if (!this.props.contactGroupToUpdate.contacts.some(contact => contact.contactId === updatedContact.contactId)) {
                return true;
            }
        });

        return false;
    }

    shouldAddContactButtonBeEnabled = () => {
        return this.getAddContactButtonTooltip() === null;
    }

    getAddContactButtonTooltip = () => {
        if (!this.props.isOpen) {
            return null;
        }

        if (this.state.updatedContacts.length >= maximumNumberOfContacts) {
            return "Maximum number of contacts reached";
        }

        if (!this.state.selectedContactOption) {
            return "No more contacts to add";
        }

        return null;
    }

    getAvailableContactsExcept = (updatedContacts) => {
        const availableContacts = this.props.contacts.filter(contact => !updatedContacts.some(updatedContact => updatedContact.contactId === contact.contactId));

        return availableContacts;
    }

    render() {
        const headerText = this.props.isUpdate ? 'Update ContactGroup' : 'Add ContactGroup';
        const doneButtonText = this.props.isUpdate ? 'Update' : 'Add';

        return <Modal show={this.props.isOpen} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="mt-3" onSubmit={e => e.preventDefault()}>
                    <Form.Group controlId="newContactGroupName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter name" value={this.state.name} autoComplete="off" onChange={this.handleNameChanged} />
                    </Form.Group>
                    <Form.Group controlId="newContactGroupDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" placeholder="Enter description" value={this.state.description} autoComplete="off" onChange={this.handleDescriptionChanged} />
                    </Form.Group>
                    <h5>
                        Current Contacts
                    </h5>
                    <table className="table table-striped table-bordered my-4">
                        <thead className="thead-dark">
                            <tr key="modalContactsHeader">
                                <th scope="col">Name</th>
                                <th scope="col" width="70px">Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.updatedContacts.map((contact) => {
                                return <tr key={contact.contactId}>
                                    <td className="align-middle">
                                        {contact.name}
                                    </td>
                                    <td className="align-middle">
                                        <DeleteButton tooltip="Delete contact" onClick={() => this.handleContactDelete(contact)} />
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                    <Form.Group as={Row} controlId="newContactGroupContacts">
                        <Col sm="8">
                            <Select isSearchable={true} value={this.state.selectedContactOption} options={this.state.contactOptions} onChange={this.handleSelectedContactChange} placeholder='No more contacts' />
                        </Col>    
                        <ButtonWithDisabledTooltip color='primary' size='sm' disabled={!this.shouldAddContactButtonBeEnabled()} disabledTooltip={this.getAddContactButtonTooltip()} onClick={this.handleContactAdd}>
                            Add contact
                        </ButtonWithDisabledTooltip>                                                
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                <ButtonWithDisabledTooltip color="primary" disabled={!this.shouldAddOrUpdateButtonBeEnabled()} disabledTooltip={this.getAddOrUpdateButtonTooltip()} onClick={this.handleDoneButtonClicked}>{doneButtonText}</ButtonWithDisabledTooltip>{' '}
            </Modal.Footer>
        </Modal>;
    }
}

export const ModalContactGroupAddOrUpdate = (props) => {
    return (
        <ModalContactGroupAddOrUpdateInternal {...props}/>
    )
}